
import React from 'react';
import styles from '../style/components/ProgressBar.module.css';

const ProgressBar = ({ progress }) => {
  return (
    <div className={styles.wrap}>
      <p>Загрузка видео на сервер!</p>
      <div className={styles.wrapper}>
        <div className={styles.bar} style={{ width: `${progress}%` }}>
          <span className={styles.label}>{progress}%</span>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
